import { Tile as TileLayer } from 'ol/layer';
import { XYZ } from 'ol/source';
import { Circle, Fill, Stroke, Style } from 'ol/style';

export function createTileLayer() {
  return new TileLayer({
    source: new XYZ({
      url: 'https://{a-d}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png',
      attributions: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> &copy; <a href="https://carto.com/">CARTO</a>',
      maxZoom: 20,
      wrapX: false,
    }),
  });
}

export const MARKER_STYLES = {
  common: new Style({
    image: new Circle({
      radius: 5,
      stroke: new Stroke({ color: '#fff', width: 1.5 }),
      fill: new Fill({ color: '#6366f1' }), // indigo
    }),
  }),
  hover: new Style({
    image: new Circle({
      radius: 6,
      stroke: new Stroke({ color: '#fff', width: 2 }),
      fill: new Fill({ color: '#3b82f6' }), // blue
    }),
  }),
  clicked: new Style({
    image: new Circle({
      radius: 7,
      stroke: new Stroke({ color: '#fff', width: 2 }),
      fill: new Fill({ color: '#8b5cf6' }), // violet
    }),
    zIndex: 9000,
  }),
  incident: new Style({
    image: new Circle({
      radius: 5,
      stroke: new Stroke({ color: '#fff', width: 1.5 }),
      fill: new Fill({ color: '#ef4444' }), // red
    }),
  }),
  singlePoint: new Style({
    image: new Circle({
      radius: 8,
      stroke: new Stroke({ color: '#fff', width: 2 }),
      fill: new Fill({ color: '#6366f1' }), // indigo
    }),
  }),
};

export function getLocationText(location) {
  if (location && Array.isArray(location) && location.length === 2) {
    return `[${location[0]}, ${location[1]}]`;
  }
}

export function getLocationTitle(report) {
  if (report) {
    return report.postcode || getLocationText(report.location);
  }
}
